import requestFile from '@/utils/request-file'

export function uploadImg(data) {
  return requestFile({
    url: '/oss-api/file/image',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: data
  })
}

export function uploadFile(data) {
  return requestFile({
    url: '/oss-api/file/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: data
  })
}

export function uploadFileWithProgress(config) {
  return requestFile({
    url: '/oss-api/file/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: config.data,
    onUploadProgress: config.onUploadProgress
  })
}

export function fetchRelativePath(params) {
  return requestFile({
    url: '/oss-api/file/url',
    method: 'get',
    params
  })
}

export function uploadPublicImg(data) {
  return requestFile({
    url: '/oss/public/image',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: data
  })
}
